<div class="faq-page">

    <!-- =====================================================
         HERO
    ====================================================== -->

    <section class="faq-hero">

        <div class="faq-container">

            <h1 class="faq-hero-title">
                Frequently Asked
                <span>Questions</span>
            </h1>

            <p class="faq-hero-description">
                Everything agents, buyers, and sellers ask us about
                how speKwo quotes and repairs work.
                Can't find it here?
                <a href="/contact">
                    Ask us directly
                </a>
                or call
                <a href="tel:7046261776">
                    704.626.1776
                </a>.
            </p>

        </div>

    </section>


    <!-- =====================================================
         FAQ LIST
    ====================================================== -->

    <section class="faq-list-section">

        <div class="faq-container">

            <!-- Loading -->

            <div
                class="faq-loader"
                *ngIf="isPageLoader"
            >

                <div class="loader-spinner"></div>

                <span>
                    Loading questions...
                </span>

            </div>


            <!-- FAQ LIST -->

            <div
                class="faq-list"
                *ngIf="!isPageLoader && faqList.length > 0"
            >

                <div
                    *ngFor="
                        let faq of faqList;
                        let i = index
                    "
                    class="faq-card"
                    [class.open]="faq.isOpen"
                    [attr.data-reveal]="true"
                    [attr.data-reveal-delay]="i * 40"
                >

                    <!-- QUESTION -->

                    <button
                        type="button"
                        class="faq-question"
                        (click)="toggleAccordion(i)"
                        [attr.aria-expanded]="faq.isOpen"
                    >

                        <span class="question-text">
                            {{ faq.question }}
                        </span>

                        <span
                            class="faq-plus"
                            [class.rotate]="faq.isOpen"
                        >
                            +
                        </span>

                    </button>


                    <!-- ANSWER -->

                    <div
                        class="faq-answer"
                        [class.show]="faq.isOpen"
                    >

                        <div class="faq-answer-inner">

                            <p>
                                {{ faq.answer }}
                            </p>

                        </div>

                    </div>

                </div>

            </div>


            <!-- NO FAQ -->

            <div
                class="faq-empty"
                *ngIf="
                    !isPageLoader &&
                    faqList.length === 0
                "
            >

                <h3>
                    Questions are currently unavailable.
                </h3>

                <p>
                    Please try again shortly.
                </p>

            </div>

        </div>

    </section>


    <!-- =====================================================
         CTA
    ====================================================== -->

    <section class="faq-cta-section">

        <div class="faq-container">

            <div
                class="faq-cta"
                data-reveal
                data-reveal-delay="0"
            >

                <div class="faq-cta-content">

                    <h2>
                        Ready to speKwo it?
                    </h2>

                    <p>
                        Send us your inspection report and have
                        one neutral number back in 24–72 hours,
                        7 days a week.
                    </p>

                </div>


                <a
                    routerLink="/spekwo-products" [queryParams]="{ product: 'full' }"
                    class="faq-cta-button"
                >

                    Request a Quote

                    <span>
                        →
                    </span>

                </a>

            </div>

        </div>

    </section>

</div>